import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = []

  changeExamVariationStatus(changeEvent) {
    let selectElem = changeEvent.target;
    let newStatus  = selectElem.value
    let oldStatus = selectElem.dataset.previousValue
    let url        = selectElem.closest('td').dataset.examVariationUrl
    let validateUrl = selectElem.closest('td').dataset.validateExamVariationUrl;
    let variationId = selectElem.closest('td').dataset.variationId;

    if (newStatus === "available") {
      this.validateExamVariation(validateUrl, newStatus, url, selectElem,oldStatus,variationId);
    } else {
      this.updateStatus(url, newStatus);
    }
  }

  validateExamVariation(validateUrl, newStatus, url, selectElem,oldStatus, variationId) {
    $.ajax({
      url: validateUrl,
      type: "GET",
      dataType: "json",
      success: (response) => {
        if (response.status === 'ok') {
          this.updateStatus(url, newStatus);
        }else {
          this.revertStatus(selectElem, oldStatus, variationId);
          this.showWarningModal(response.html);
        }
      },
    });
  }

  updateStatus(url, newStatus) {
    $.ajax({
      url: url,
      type: "PATCH",
      async: true,
      dataType: "json",
      data: {
        assessment_exam_variation: {
          status: newStatus
        }
      }
    });
  }

  showWarningModal(htmlContent) {
    const container = document.getElementById('warning-modal-container');
    container.innerHTML = htmlContent;

    // Wait for DOM to update before attaching event listener
    requestAnimationFrame(() => {
      const closeBtn = document.getElementById('close-warning-modal-button');
      if (closeBtn) {
        closeBtn.addEventListener('click', () => {
          container.innerHTML = '';
        });
      }
    });
  }

  revertStatus(selectElem, oldStatus, variationId) {
    // Reset select value
    selectElem.value = oldStatus;
    selectElem.selectedIndex = [...selectElem.options].findIndex(opt => opt.value === oldStatus);
    selectElem.dispatchEvent(new Event('change', { bubbles: true }));

    // Update the displayed span if it exists
    const spanElem = document.getElementById(`status-span-${variationId}`);
    if (spanElem) {
      spanElem.textContent = oldStatus.charAt(0).toUpperCase() + oldStatus.slice(1);
    }
  }

  storePreviousValue(event) {
    event.target.dataset.previousValue = event.target.value;
  }
}
